export function toChartData(values, productName = "No name", t, i18n) {

  if (
    values &&
    Array.isArray(values) &&
    values.length > 0
  ) {
    var chartDataItemsList = processData(values, t, i18n);

    chartDataItemsList.sort((a, b) => a.order - b.order);
    // Construct the final chart data object
    let chartData = {
      chartData: chartDataItemsList,
      productName: productName,
      overallLabel: t('overallLabel'),
    };

    return chartData;
  }
}

export function getAssetClassType(assetClass) {
  switch (assetClass) {
    case "FIXED INCOME":
      return "bonds";
    case "EQUITY":
      return "equity";
    default:
      return "others";
  }
}

const processData = (data, t, i18n) => {

  const result = [];
  let totalAllotment = 0;

  data.forEach((item) => {
    const assetType = getAssetClassType(item.AssetClass);
    switch (assetType) {
      case "bonds":
      case "equity":
        result.push({
          name: item.AssetClass.toLowerCase(),
          label: i18n.exists(item.label) ? t(item.label) : item.label,
          legend: true,
          allotment: item.value,
        });
        totalAllotment += item.value;
        break;
      default:
        const othersIndex = result.findIndex(
          (entry) => entry.name === "others"
        );
        if (othersIndex !== -1) {
          result[othersIndex].allotment += item.value;
        } else {
          result.push({
            name: "others",
            label: t('othersLabel'),
            legend: true,
            allotment: item.value.toFixed(2),
          });
        }
        totalAllotment += item.value;
    }
  });

  if (totalAllotment < 100) {
    result.push({
      name: "cash",
      label: t('cashLabel'),
      legend: true,
      // allotment: 100 - totalAllotment
      allotment: (100 - totalAllotment).toFixed(2),
    });
  }

  return result;
};

export function sortByAssetClassType(funds) {
  return funds.sort((a, b) => {
    const typeA = getAssetClassType(a.AssetClass);
    const typeB = getAssetClassType(b.AssetClass);
    if (typeA === typeB) {
		return a.order - b.order;
    } else {
		const order = ["others", "bonds", "equity"];
		return order.indexOf(typeB) - order.indexOf(typeA);
    }
  });
}
